export default "__VITE_ASSET__45a12ccc__"